import uaParsed from 'util/ua';



const VERSION_DETECTS = {
  ie    : {low: 7, high: 11},
  safari: {low: 5, high: 15},
}

const state = {};
state.parsed = uaParsed;
state.matchs = [];
state.browser = {
  name   : state.parsed.browser.name.toLowerCase(),
  major  : parseInt(state.parsed.browser.major, 10),
  version: parseInt(state.parsed.browser.version, 10),
};
if (state.browser.name === 'mobile safari') state.browser.name = 'safari';
state.browser.totalName = state.browser.name + state.browser.version;

state.device = {
  model: state.parsed.device.model ? state.parsed.device.model.toLowerCase() : null,
  type : state.parsed.device.type  ? state.parsed.device.type.toLowerCase()  : 'console',
};

state.device.type = state.device.type === 'mobile' ? 'phone' : state.device.type;

state.os = {
  name   : state.parsed.os.name.toLowerCase().split(' ')[0],
  version: parseInt(state.parsed.os.version, 10),
};
state.os.version = isNaN(state.os.version) ? null : state.os.version;
state.os.totalName = state.os.version ? state.os.name + state.os.version : state.os.name;

state.matchs.push(state.browser.name);
state.matchs.push(state.browser.totalName);
state.matchs.push(state.device.type);
state.matchs.push(state.os.name);

if (state.parsed.device.type) {
  if (state.device.model) state.matchs.push(state.device.model);
  state.matchs.push('mobile');
}
if (state.os.version) state.matchs.push(state.os.totalName);

for (let match of state.matchs) {
  if (match.match(/^windows/)) state.matchs.push(match.replace(/^windows/, 'win'));
}

// detect version
for (let key in VERSION_DETECTS) {
  if (state.browser.name === key) {
    let target = VERSION_DETECTS[key];
    state.matchs.push('gte-' + state.browser.name + state.browser.version);
    state.matchs.push('lte-' + state.browser.name + state.browser.version);
    for (let i = target.low; i < state.browser.version; i++) {
      state.matchs.push('gt-' + state.browser.name + i);
    }
    for (let i = state.browser.version; i < target.high; i++) {
      state.matchs.push('lt-' + state.browser.name + (i + 1));
    }
  }
}



const $html = document.documentElement;
$html.className = ($html.className || '') + ' ' + state.matchs.map(match => `ua-${match}`).join(' ');



export default {
  namespaced: true,

  state,

  getters: {
    is: state => key => state.matchs.includes(key.toLowerCase()),
    isAny: (state, getters) => keys => {
      keys = Array.isArray(keys) ? keys : [keys];
      for (let key of keys) {
        if (getters['is'](key)) return true;
      }
      return false;
    },
    isAll: (state, getters) => keys => {
      keys = Array.isArray(keys) ? keys : [keys];
      for (let key of keys) {
        if (!getters['is'](key)) return false;
      }
      return true;
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/store/modules/ua.js